import React, { useState } from 'react';
import { useViewlogies } from 'context';
import { appendCarePackageOrderCookie } from 'services/carePackage';
import StepIndicator from './components/StepIndicator';
import PastOrders from './components/PastOrders';
import GetStarted from './steps/GetStarted';
import SelectPackage from './steps/SelectPackage';
import ReviewOrder from './steps/ReviewOrder';
import SubmitPayment from './steps/SubmitPayment';
import Confirmation from './steps/Confirmation';
import './carePackage.scss';

const CarePackage = () => {
    const {
        event: { id: eventId, lastName },
    } = useViewlogies();

    const [currentStep, setCurrentStep] = useState('getStarted');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [message, setMessage] = useState('');
    const [fromName, setFromName] = useState('');
    const [orderNumber, setOrderNumber] = useState(null);

    const handleProductSelect = product => {
        setSelectedProduct(product);
        setCurrentStep('reviewOrder');
    };

    const handlePaymentSuccess = ({ orderNumber: num }) => {
        setOrderNumber(num);
        appendCarePackageOrderCookie(eventId, {
            orderNumber: num,
            productId: selectedProduct?.id,
            productName: selectedProduct?.name,
        });
        setCurrentStep('confirmation');
    };

    const handleRestart = () => {
        setSelectedProduct(null);
        setMessage('');
        setFromName('');
        setOrderNumber(null);
        setCurrentStep('selectPackage');
    };

    const BACK_STEPS = {
        selectPackage: 'getStarted',
        reviewOrder: 'selectPackage',
        submitPayment: 'reviewOrder',
    };

    const handleBack = () => setCurrentStep(BACK_STEPS[currentStep]);

    const showBack = currentStep in BACK_STEPS;

    return (
        <div className="care-package">
            {currentStep !== 'confirmation' && (
                <aside className="care-package-sidebar">
                    <StepIndicator currentStep={currentStep} lastName={lastName} />
                </aside>
            )}

            <div className="care-package-content">
                {showBack && (
                    <button className="care-package-back-btn" onClick={handleBack} type="button">
                        ← Back
                    </button>
                )}

                {currentStep === 'getStarted' && (
                    <>
                        <PastOrders eventId={eventId} />
                        <GetStarted onNext={() => setCurrentStep('selectPackage')} />
                    </>
                )}

                {currentStep === 'selectPackage' && <SelectPackage onSelect={handleProductSelect} />}

                {currentStep === 'reviewOrder' && selectedProduct && (
                    <ReviewOrder
                        product={selectedProduct}
                        message={message}
                        fromName={fromName}
                        onMessageChange={setMessage}
                        onFromNameChange={setFromName}
                        onNext={() => setCurrentStep('submitPayment')}
                    />
                )}

                {currentStep === 'submitPayment' && selectedProduct && (
                    <SubmitPayment
                        product={selectedProduct}
                        message={message}
                        fromName={fromName}
                        onSuccess={handlePaymentSuccess}
                    />
                )}

                {currentStep === 'confirmation' && selectedProduct && orderNumber && (
                    <Confirmation product={selectedProduct} orderNumber={orderNumber} onRestart={handleRestart} />
                )}
            </div>
        </div>
    );
};

export default CarePackage;
